import React from 'react';
import { Star, Quote } from 'lucide-react';
import { Card } from './ui/card';
import { Avatar, AvatarFallback } from './ui/avatar';
import { scellantTestimonials } from '../data/mock';

const ScellantTestimonials = () => {
  const getInitials = (name) => {
    return name
      .split(' ')
      .map((n) => n[0])
      .join('')
      .toUpperCase();
  };

  return (
    <section className="py-24 bg-black">
      <div className="container mx-auto px-4">
        {/* Section Header */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <div className="inline-flex items-center space-x-2 bg-red-900/30 border border-red-500/30 rounded-full px-4 py-2 mb-6">
            <Star size={18} className="text-red-500" />
            <span className="text-sm font-semibold text-white">Témoignages</span>
          </div>
          <h2 className="text-4xl md:text-5xl font-bold mb-6">
            <span className="text-white">Ce que disent</span>{' '}
            <span className="bg-gradient-to-r from-red-600 to-red-500 bg-clip-text text-transparent">
              nos clients
            </span>
          </h2>
          <p className="text-xl text-gray-400">
            Des résultats qui parlent d'eux-mêmes. Fiabilité et qualité reconnues.
          </p>
        </div>

        {/* Testimonials Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6 max-w-6xl mx-auto">
          {scellantTestimonials.map((testimonial, index) => (
            <Card
              key={testimonial.id}
              className="p-6 hover:shadow-2xl hover:shadow-red-500/20 transition-all duration-300 hover:-translate-y-2 border border-red-500/20 bg-gray-900 relative"
              style={{ animationDelay: `${index * 100}ms` }}
            >
              {/* Quote Icon */}
              <div className="absolute top-4 right-4 text-red-900/40">
                <Quote size={32} />
              </div>

              {/* Rating */}
              <div className="flex space-x-1 mb-4">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <Star
                    key={i}
                    className="fill-red-500 text-red-500"
                    size={16}
                  />
                ))}
              </div>

              {/* Testimonial Text */}
              <p className="text-gray-300 mb-6 text-sm leading-relaxed">
                "{testimonial.text}"
              </p>

              {/* Author Info */}
              <div className="flex items-center space-x-3 pt-4 border-t border-red-500/20">
                <Avatar className="bg-gradient-to-br from-red-600 to-red-500 text-white">
                  <AvatarFallback>{getInitials(testimonial.name)}</AvatarFallback>
                </Avatar>
                <div>
                  <h4 className="font-bold text-white text-sm">
                    {testimonial.name}
                  </h4>
                  <p className="text-xs text-gray-400">
                    {testimonial.location}
                  </p>
                </div>
              </div>

              {/* Accent Line */}
              <div className="absolute bottom-0 left-0 right-0 h-1 bg-gradient-to-r from-red-600 to-red-500"></div>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ScellantTestimonials;
